import React from 'react';
// import {withSnackbar} from "notistack";
import {Link} from 'react-router-dom';
import {Modal} from "react-bootstrap";
import "./Modal.css"
import Utils from '../../../utils/utils';

function formatMoney(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
function onlyNumber(value) {
    return  Utils.filterNumberOnly(value);
}

class modalCreateTermNumber extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCreate: true,
            type: '',
            termNumber: '',
            price: '',
        };
    }

    onSubmit = () => {
        let {} = this.state;
        let payload = {};

    }

    onSubmit = () => {
        let {termNumber, price} = this.state;
        let item = {
            countTerm: termNumber,
            price: price
        };
        this.props.create(this.props.type, item)
        this.setState({termNumber: '', price: ''})
    }

    render() {
        const modalProp = {
            show: this.props.show,
            // onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>THÊM MỚI SỐ KỲ</b>
                            </h1>
                        </div>
                        <div className='mt-3 mb-3'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Số kỳ(tháng)</label>
                                    <input
                                        maxLength={3} type="text"
                                        className="form-control shadow-none"
                                        value={this.state.termNumber}
                                        onChange={(event) => {
                                            this.setState({
                                                termNumber: onlyNumber(event.target.value)
                                            })
                                        }}
                                    />

                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Giá gói cước</label>
                                    <input
                                        type="text"
                                        maxLength={10}
                                        className="form-control shadow-none"
                                        value={formatMoney(this.state.price)}
                                        onChange={(event) => {
                                                this.setState({
                                                    price: onlyNumber(event.target.value.trim())
                                                }, () => {
                                                    console.log(this.state.price)
                                                })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                    disabled={this.state.termNumber.length === 0 || this.state.price.length === 0}
                                    onClick={() => this.onSubmit()}
                                >
                                    Đồng ý
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-light shadow-none"
                                    onClick={this.props.onHide}
                                >
                                    Hủy bỏ
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default modalCreateTermNumber
